<loading-layout #loadingLayout>
    <div *ngIf="!loadingLayout.loading">
        <h3>Gracias por confirmar!</h3>
    </div>
</loading-layout>
